import { SimpleFunction, SimpleAVHandler, SimpleATHandler } from 'src/app/types/@types/sl-v-types';
import { ModalSelectDialogService, SelectOption } from './../dialogs/modal-select-dialog/modal-select-dialog.service';
import { Component, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, EventEmitter, AfterViewInit, Output } from '@angular/core';


@Component({
  selector: 'app-popup-select-input',
  templateUrl: './popup-select-input.component.html',
  styleUrls: ['./popup-select-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupSelectInputComponent implements AfterViewInit {

  @Input() optionGetter: SimpleATHandler<PopupSelectInputComponent, Array<SelectOption>>;
  @Input() defaultText: string = 'Select an option';
  private _value?: string;
  @Input()
  set value(val: string) {
    this._value = val;
  }
  get value():string {
    return this._value;
  }
  @Output()
  public valueChange = new EventEmitter<string>();
  private _selectedIndex = 0;
  public get selectedIndex(): number {
    return this._selectedIndex;
  }

  private selected: SelectOption = { label: 'Select an option', value: undefined };

  public get label() {
    if (!this.selected) return this.defaultText;
    return this.selected.label;
  }
  @Output()
  public onChange = new EventEmitter<string>();

  constructor(private optionSvc: ModalSelectDialogService, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.selected.label = this.defaultText;
    const options = this.optionGetter(this);
    if (!options) return;
    if (options.length === 0) return;
    this._selectedIndex = -1;
    options.every((option, index) => {
      if (option.value === this.value) {
        this._selectedIndex = index;
        this.selected = option;
        return false;
      }
      return true;
    })

    this.cdr.detectChanges();
  }
  Show() {
    const options = this.optionGetter(this);
    if (!options) return;
    if (options.length === 0) return;
    this.optionSvc.Show((option: SelectOption) => {
      const oldVal: any = (!!this.selected) ? this.selected.value : undefined;
      this.selected = option;
      this.cdr.detectChanges();
      this.value = this.selected.value;
      this.valueChange.emit(this.value);
    }, options, this.selectedIndex);

  }
}
